import { ReactNode, useCallback } from "react"

import { ArrowBackIcon } from "@chakra-ui/icons"
import {
  Box,
  Button,
  Divider,
  IconButton,
  Text,
  useMediaQuery,
} from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"

import { useAppSelector } from "app/hooks"
import ProtectedComponent from "components/PleaseLoginComp"
import MobileSideMenu from "components/sidemenu/mobilesidemenu"
import DesktopSideMenu from "components/sidemenu/sidemenu"
import { MenuItem as MenuItemType } from "components/sidemenu/types"
import Tabs from "components/tabs/Tabs"
import useIsPermitted from "hooks/useIsPermittedHook/useIsPermitted"
import { HOST_TAB_LIST } from "layouts/host-properties-layout"
import {
  selectProperty,
  selectPropertyName,
  selectPropertyTypeDesc,
} from "store/property/propertySlice"

type HostListingLayoutProps = {
  children: ReactNode
}
export const sidebarMenuArr: MenuItemType[] = [
  // Note: Uncomments this to unable calendar.
  // {
  //   name: "Calendar",
  //   depth: 1,
  //   id: "calendar",
  //   makeTo: (propertyId) => `/listings/properties/calendar/${propertyId}`,
  //   childMenu: [],
  // },
  {
    name: "Property details",
    depth: 1,
    id: "Property details",
    makeTo: (propertyId) =>
      `/listings/properties/details/${propertyId}#propertyDetails`,
    childMenu: [
      {
        name: "PMC Description",
        depth: 2,
        id: "propertyDetails",
        makeTo: (propertyId) =>
          `/listings/properties/details/${propertyId}#propertyDetails`,

        childMenu: [],
        isActive: true,
      },
      {
        name: "Whimstay Description",
        depth: 2,
        id: "whimstayDescription",
        makeTo: (propertyId) =>
          `/listings/properties/details/${propertyId}#whimstayDescription`,

        childMenu: [],
        isActive: true,
      },
      {
        name: "Videos and Pictures",
        depth: 2,
        id: "videosAndPictures",
        makeTo: (propertyId) =>
          `/listings/properties/details/${propertyId}#videosAndPictures`,
        childMenu: [],
      },
      // {
      //   name: "Amenities",
      //   depth: 2,
      //   id: "amenities",
      //   makeTo: (propertyId) =>
      //     `/listings/properties/details/${propertyId}#amenities`,
      //   childMenu: [],
      // },
      // {
      //   name: "House Rules",
      //   depth: 2,
      //   id: "houserules",
      //   makeTo: (propertyId) =>
      //     `/listings/properties/details/${propertyId}#houserules`,
      //   childMenu: [],
      // },
      // {
      //   name: "Reviews and Ratings",
      //   depth: 2,
      //   id: "reviewAndRatings",
      //   makeTo: (propertyId) =>
      //     `/listings/properties/details/${propertyId}#reviewAndRatings`,
      //   childMenu: [],
      // },
    ],
  },
]
const HostListingLayout = (props: HostListingLayoutProps) => {
  const { children } = props
  const navigate = useNavigate()
  const [isMobile] = useMediaQuery("(max-width: 1024px)")
  const propertyName = useAppSelector(selectPropertyName)
  const property = useAppSelector(selectProperty)
  const hasAccessTo = useIsPermitted()
  const propertyTypeDesc = useAppSelector(selectPropertyTypeDesc)

  const goBack = () => {
    navigate(-1) // This will navigate back to the previous page.
  }

  const openListing = useCallback(() => {
    if (property && propertyName)
      window.open(
        `${process.env.REACT_APP_WHIMSTAY_WEB_URL || ""}/detail/${propertyName
          ?.toLowerCase()
          .replace(/ /g, "-")}/${property.propertyId}`,
        "_blank",
      )
  }, [property, propertyName])

  return (
    <Box maxW='100%' px={{ base: "20px", lg: "30px", xl: "70px" }} minW='100%'>
      <Box py={{ base: "0", md: "16px" }} mx={{ base: "-20px", md: "0" }}>
        <Tabs tabsArr={HOST_TAB_LIST} />
      </Box>
      <Divider borderColor='#e1e1e1' />
      <Box
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        gap='16px'
        p={3}
      >
        {/* title and create button */}
        <Box display='flex' alignItems='center'>
          <IconButton
            size='sm'
            variant='outline'
            aria-label='Subtract'
            icon={<ArrowBackIcon h='30px' w='30px' />}
            data-testid='back'
            onClick={goBack}
          />
          {/* {propertyName && ( */}
          <Text
            pl='10px'
            size={{ base: "sm", sm: "md", md: "xl" }}
            variant='black'
            fontWeight='700'
            display='webkit-box'
            maxW={{ base: "150px", md: "full" }}
            noOfLines={{ base: 2 }}
          >
            {propertyName || propertyTypeDesc || "UNNAMED_PROPERTY"}
          </Text>
          {/* )} */}
        </Box>
        {(isMobile && (
          <MobileSideMenu
            sidebarMenuArr={[
              ...sidebarMenuArr,
              {
                name: "Listing",
                depth: 1,
                id: "Listing",
                onMenuItemClick: openListing,
                childMenu: [],
              },
            ]}
          />
        )) || (
          <Button
            ml={{ base: "0", sm: "auto" }}
            size='sm'
            onClick={openListing}
            disabled={!hasAccessTo.listingPropertiesDetails}
          >
            Listing
          </Button>
        )}
      </Box>
      <Box mt={8} display='flex' gap={10}>
        <Box
          w='210px'
          flexGrow={1}
          flexShrink={0}
          display={{ base: "none", lg2: "block" }}
        >
          <DesktopSideMenu sidebarMenuArr={sidebarMenuArr} />
        </Box>
        <Box pr={{ base: 0, xl: 10 }} w='full'>
          <ProtectedComponent>{children}</ProtectedComponent>
        </Box>
      </Box>
    </Box>
  )
}

export default HostListingLayout
